// Slick init — only the .ctm_frequently selector is actually used on product
// templates. The previous custom-dj.js shipped three additional init blocks
// (.ctm-index .ctm_slick_slider, .ctm-index .Ctm_best_seller, .InstaFeed
// .multicolumn-list) whose selectors don't match any section in the codebase;
// they were dead code and have been dropped to keep this file small.
(function () {
  if (typeof window.jQuery === 'undefined') return;
  jQuery(function ($) {
    if (!$('.ctm_frequently .collection .product-grid').length) return;
    $('.ctm_frequently .collection .product-grid').slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      centerMode: true,
      prevArrow: "<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0694/0367/2731/files/back.png?v=1758211985'>",
      nextArrow: "<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0694/0367/2731/files/next.png?v=1758211984'>",
      centerPadding: '60px',
      slidesToScroll: 4,
      responsive: [
        { breakpoint: 1366, settings: { slidesToShow: 3, slidesToScroll: 3, infinite: true, dots: true } },
        { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 2, arrows: false } },
        { breakpoint: 480, settings: { slidesToShow: 2, slidesToScroll: 2, centerPadding: '0px', arrows: true } }
      ]
    });
  });
})();
